import type { NestedOption } from '@/scopes/common/components/Filters/GroupedAirportFilter/types'
import type { Option } from '@/scopes/prices/domain/filters/types'
import { FilterOption } from '@/scopes/search/types'

export function mapOptions(originalOptions: Option[] | FilterOption<string>[]): NestedOption[] {
  const groups = new Set(originalOptions.map(option => option.groupInfo))
  return Array.from(groups).map((group) => {
    const children = originalOptions.filter(option => option.groupInfo === group)
    return {
      id: group,
      value: group,
      selected: false,
      children: children.map(child => ({
        id: child.value,
        value: child.name,
        trailing: child.value,
      })),
    } as NestedOption
  })
}
